module.exports = __webpack_public_path__ + "static/media/video-upload.e722fceb.svg";